module.exports = __webpack_public_path__ + "img/Clean  building rubble.89344b1e.svg";